var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.53846C7.32682 3.53846 3.53846 7.32682 3.53846 12C3.53846 16.6732 7.32682 20.4615 12 20.4615C16.6732 20.4615 20.4615 16.6732 20.4615 12C20.4615 7.32682 16.6732 3.53846 12 3.53846ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9.40479 9.40479C9.70519 9.10439 10.1922 9.10439 10.4926 9.40479L12 10.9121L13.5074 9.40479C13.8078 9.10439 14.2948 9.10439 14.5952 9.40479C14.8956 9.70519 14.8956 10.1922 14.5952 10.4926L13.0879 12L14.5952 13.5074C14.8956 13.8078 14.8956 14.2948 14.5952 14.5952C14.2948 14.8956 13.8078 14.8956 13.5074 14.5952L12 13.0879L10.4926 14.5952C10.1922 14.8956 9.70519 14.8956 9.40479 14.5952C9.10439 14.2948 9.10439 13.8078 9.40479 13.5074L10.9121 12L9.40479 10.4926C9.10439 10.1922 9.10439 9.70519 9.40479 9.40479Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseJob);
export default __webpack_public_path__ + "static/media/close-job.f1beec6a31571daddffef909de441ef2.svg";
export { ForwardRef as ReactComponent };